import { CMultiSelect, CNavItem } from '@coreui/react-pro';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LocalStorage from '../../utils/local_storage';
import { CUSTOMER_SELECTED } from '../../actions';
import { useLocation } from 'react-router-dom';

const ClientSelector = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const customers = useSelector((state) => state.customer?.list);

	const [options, setOptions] = useState([]);

	useEffect(() => {
		if (customers && customers.length > 0) {
			let currentOption = LocalStorage.getCurrentCustomer();
			let currentCustomer = null;
			if (!currentOption) {
				currentOption = customers[0]._id;
				currentCustomer = customers[0];
			} else {
				currentCustomer = customers.filter((customer) => customer._id ===currentOption).pop();
				if (!currentCustomer) {
					currentCustomer = customers[0];
					currentOption = customers[0]._id;
				}
			}
			// Sort customers alphabetically by name before mapping to options
			const sortedCustomers = [...customers].sort((a, b) => a.name.localeCompare(b.name));
			
			setOptions(
				sortedCustomers.map((customer) => {
					if (customer._id ===currentOption) {
						customer.selected = true;
					}
					return {
						value: customer._id,
						text: customer.name,
						key: customer._id,
						selected: !!customer.selected,
					};
				})
			);
		}
	}, [customers]);

	const handleChange = (item) => {
		if (item[0]) {
			let currentOption = item[0];
			LocalStorage.setCurrentCustomer(currentOption.value);
			dispatch({
				type: CUSTOMER_SELECTED,
				payload: customers.filter((customer) => customer._id ===currentOption.value).pop(),
			});
		}
	};

	const canChangeClient = () => {
		return location.pathname.endsWith('/customize');
	};

	return (
		<CNavItem className='top-nav-dropdown'>
			<CMultiSelect 
				style={{ padding: '0 !important' }} 
				placeholder='Select Client' 
				optionsStyle='text' 
				multiple={false} 
				search={true} 
				options={options} 
				onChange={handleChange} 
				disabled={canChangeClient()} 
				clearsearch={false} 
				allowClear={false}
				optionsMaxHeight="300px"
				virtualScroller={true}
				visibleOptions={10}
				scrollHeight="300px"
			/>
		</CNavItem>
	);
};

export default ClientSelector;
